import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { injectCss } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import styled, { css } from "styled-components";

const enum fields {
    backgroundColor = "backgroundColor",
    paddingTop = "paddingTop",
    paddingBottom = "paddingBottom",
    paddingRight = "paddingRight",
    paddingLeft = "paddingLeft",
    borderRadius = "borderRadius",
}

interface OwnProps extends WidgetProps {
    fields: {
        backgroundColor: string;
        paddingTop: string;
        paddingBottom: string;
        paddingRight: string;
        paddingLeft: string;
        borderRadius: string;
    };
}

export interface ContainerStyles {
    container?: InjectableCss;
}

const styles: ContainerStyles = {
    container: {
        css: css`
            [class^="GridOffset"] {
                width: 100% !important;
            }
        `,
    },
};

const CrescentCustomContainer: FC<OwnProps> = ({ fields, id }) => {
    const { backgroundColor, paddingBottom, paddingTop, paddingLeft, paddingRight, borderRadius } = fields;
    return (
        <StyledWrapper {...styles.container}>
            <ContentWrapper
                backgroundColor={backgroundColor}
                paddingBottom={paddingBottom}
                paddingTop={paddingTop}
                paddingRight={paddingRight}
                paddingLeft={paddingLeft}
                borderRadius={borderRadius}
            >
                <Zone zoneName="Content" contentId={id} />
            </ContentWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: CrescentCustomContainer,
    definition: {
        group: "Common",
        displayName: "Crescent Custom Container",
        fieldDefinitions: [
            {
                fieldType: "General",
                name: fields.backgroundColor,
                editorTemplate: "ColorPickerField",
                displayName: "Background Color",
                defaultValue: "",
            },
            {
                fieldType: "General",
                name: fields.paddingTop,
                editorTemplate: "TextField",
                displayName: "Padding Top",
                defaultValue: "",
            },
            {
                fieldType: "General",
                name: fields.paddingBottom,
                editorTemplate: "TextField",
                displayName: "Padding Bottom",
                defaultValue: "",
            },
            {
                fieldType: "General",
                name: fields.paddingLeft,
                editorTemplate: "TextField",
                displayName: "Padding Left",
                defaultValue: "",
            },
            {
                fieldType: "General",
                name: fields.paddingRight,
                editorTemplate: "TextField",
                displayName: "Padding Right",
                defaultValue: "",
            },
            {
                fieldType: "General",
                name: fields.borderRadius,
                editorTemplate: "TextField",
                displayName: "Border Radius",
                defaultValue: "",
            },
        ],
    },
};

export default widgetModule;

export const ContentWrapper = styled.div<
    {
        backgroundColor: string;
        paddingTop: number | string;
        paddingBottom: number | string;
        paddingRight: number | string;
        paddingLeft: number | string;
        borderRadius: number | string;
    } & InjectableCss
>`
    ${({ backgroundColor }) => (backgroundColor ? `background-color: ${backgroundColor};` : null)};
    ${({ paddingTop }) => (paddingTop ? `padding-top: ${paddingTop}px;` : null)};
    ${({ paddingBottom }) => (paddingBottom ? `padding-bottom: ${paddingBottom}px;` : null)};
    ${({ paddingRight }) => (paddingRight ? `padding-right: ${paddingRight}px;` : null)};
    ${({ paddingLeft }) => (paddingLeft ? `padding-left: ${paddingLeft}px;` : null)};
    ${({ borderRadius }) => (borderRadius ? `border-radius: ${borderRadius}px;` : null)};
    ${injectCss}
`;
